export default __webpack_public_path__ + "static/media/02.0f5fe3a0.jpg";